import { render, staticRenderFns } from "./select-platform.vue?vue&type=template&id=3f37651e"
import script from "./select-platform.vue?vue&type=script&lang=ts"
export * from "./select-platform.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports